// extracted by mini-css-extract-plugin
export var text = "OverflowText-module--text--1eVNl";
export var gradient = "OverflowText-module--gradient--2mY0t";
export var readMore = "OverflowText-module--readMore--1Hggr";